import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-number-widget',
  templateUrl: './number-widget.component.html',
  styleUrls: ['./number-widget.component.scss']
})
export class NumberWidgetComponent implements OnInit {

  @Input()
  value: number;

  @Input()
  title: string;

  constructor() {
  }

  ngOnInit(): void {
  }

}
